import React, { useState, useEffect } from "react";

const DisclaimerPage = () => {
  const [htmlContent, setHtmlContent] = useState("");
  useEffect(() => {
    fetch("/disclaimer.html")
      .then((response) => response.text())
      .then((content) => setHtmlContent(content))
      .catch((err) => console.error("Failed to load HTML:", err));
  }, []);
  return (
    <div
      className="static-html-page"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default DisclaimerPage; 